import { Component } from "@angular/core";
import { BaseSubscriptionComponent } from "src/app/components/new-product/base/base-subscription/base-subscription.component";

@Component({
    selector: "app-mf-sg-base",
    templateUrl: "./mf-sg-base.component.html",
    styleUrls: ["./mf-sg-base.component.scss"],
    standalone: false
})
export class MfSgBaseComponent extends BaseSubscriptionComponent {}
